import {
  Product,
  ProductDeliveryTypeDeliveryTypeEnum,
  Variant,
} from '@generated-client/backend';
import { Button, ButtonGroup } from '@heroui/react';
import { DELIVERY_TEXTS } from '@trwl/constants';
import { formatNumber } from '@trwl/util';
import cn from 'classnames';
import React, { Dispatch, SetStateAction } from 'react';

const DeliveryModeButton = ({
  price,
  deliveryInfo,
  deliveryMode,
  setDeliveryMode,
  targetDeliveryMode,
  disabled,
}: {
  deliveryMode: ProductDeliveryTypeDeliveryTypeEnum;
  targetDeliveryMode: ProductDeliveryTypeDeliveryTypeEnum;
  price: number;
  deliveryInfo: string;
  setDeliveryMode: (mode: ProductDeliveryTypeDeliveryTypeEnum) => void;
  disabled?: boolean;
}) => {
  return (
    <Button
      disableRipple
      isDisabled={disabled}
      radius={'sm'}
      className={cn(
        'group h-full w-full bg-[#F5F5F5] box-border',
        'overflow-hidden flex flex-col justify-center items-start px-6 py-2.5 gap-0',
        'bg-white border-[1.6px] border-[#282828]',
        'data-[active=true]:bg-primary',
      )}
      data-active={deliveryMode === targetDeliveryMode}
      onPress={() => {
        setDeliveryMode(targetDeliveryMode);
      }}
    >
      <div
        className={
          'text-[20px] leading-[24px] text-[rgba(40,40,40,0.2)] text-primary group-data-[active=true]:text-primary-foreground'
        }
      >
        {formatNumber(price)} ₽
      </div>
      <div
        className={
          'text-[14px] leading-[18px] font-light text-[rgba(150,150,150,0.8)] group-data-[active=true]:text-[#969696]'
        }
      >
        {deliveryInfo}
      </div>
    </Button>
  );
};

export const DeliveryModeSelector = ({
  state,
  variant,
  product,
}: {
  variant: Variant;
  state: [
    ProductDeliveryTypeDeliveryTypeEnum,
    Dispatch<SetStateAction<ProductDeliveryTypeDeliveryTypeEnum>>,
  ];
  product: Product;
}) => {
  const [deliveryType, setDeliveryType] = state;
  return (
    <ButtonGroup className={'h-[65px]'}>
      {product.productDeliveryTypes.map((type) => (
        <DeliveryModeButton
          key={type.deliveryType}
          setDeliveryMode={setDeliveryType}
          price={variant.price + type.amount}
          deliveryInfo={
            DELIVERY_TEXTS[type.deliveryType]?.(variant.maxDelivery) ?? ''
          }
          deliveryMode={deliveryType}
          targetDeliveryMode={type.deliveryType}
        />
      ))}
    </ButtonGroup>
  );
};
